/* Marz 0.9.0 product template behaviour. Works alongside Impulse theme.js (which owns the variant,
   gallery, URL and AJAX cart); this file only adds purchase options, per-serving prices, option card
   states and pick order, the price on the add-to-cart button, the sticky bar, the label panel switch,
   flip cards and FAQ chips. */
(function () {
  'use strict';

  var money = function (cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  };
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function autoAdvanceOnce(row) {
    if (!row || reduced) return;
    var stopped = false;
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      row.addEventListener(ev, function () { stopped = true; }, { passive: true, once: true });
    });
    setTimeout(function () { if (!stopped && row.scrollWidth > row.clientWidth + 4) row.scrollTo({ left: row.scrollWidth, behavior: 'smooth' }); }, 2600);
    setTimeout(function () { if (!stopped && row.scrollWidth > row.clientWidth + 4) row.scrollTo({ left: 0, behavior: 'smooth' }); }, 5200);
  }

  /* ---------------- variant pick order ----------------
     When the exact combination is sold out, Impulse jumps to the first in-stock variant sharing the option
     just clicked (Vanilla Ice Cream + 2 lbs became Peanut Butter Chocolate 2 lbs). On Marz product templates
     the flavor never changes behind the shopper: a flavor click lands on its in-stock size, a size click keeps
     the flavor even when that combination is sold out. */
  function patchVariants() {
    var P = window.theme && theme.Variants && theme.Variants.prototype;
    if (!P || P._mzPatched) return;
    var orig = P._getVariantFromOptions;
    P._getVariantFromOptions = function (last) {
      if (!this.container || !this.container.closest || !this.container.closest('[data-mz-pdp]')) return orig.apply(this, arguments);
      var sel = this._getCurrentOptions(), vs = this.variants;
      var flv = this.container.querySelector('[data-mz-opt="flavor"] input[data-index]');
      var key = flv ? flv.dataset.index : 'option1';
      var all = function (v) { return sel.every(function (o) { return v[o.index] === o.value; }); };
      var byLast = function (v) { return !!(last && last.index && v[last.index] === last.value); };
      var inStock = function (f) { return vs.find(function (v) { return f(v) && v.available; }); };
      return inStock(all) || (last && last.index === key && inStock(byLast)) || vs.find(all) ||
        inStock(byLast) || vs.find(byLast) || null;
    };
    P._mzPatched = true;
  }
  patchVariants();

  /* ---------------- buy box ---------------- */
  function initPdp(root) {
    if (root.dataset.mzReady) return;
    root.dataset.mzReady = '1';
    var dataEl = $('[data-mz-data]', root);
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var select = $('[data-product-select]', root);
    var plansEl = $('[data-mz-plans]', root);
    var spInput = $('[data-mz-sp]', root);
    var sticky = $('[data-mz-sticky]', root);
    var atc = $('[data-add-to-cart]', root);
    var atcText = $('[data-add-to-cart-text]', root);
    var plan = plansEl ? plansEl.dataset.default || 'sub' : 'one';
    var freq = spInput ? String(spInput.value) : null;
    // the master select omits sold-out variants, so a ?variant= link to one would fall back to another variant's price
    var vid = String(D.current || (select && select.value));

    var V = function (id) { return D.variants[String(id)]; };
    var subPrice = function (v) { return v && freq && v.sp && v.sp[freq] != null ? v.sp[freq] : null; };
    var perServing = function (cents, v) { return v && v.s ? money(Math.round(cents / v.s)) + ' per serving' : ''; };
    var unitFor = function (v) { var sp = subPrice(v); return plan === 'sub' && sp != null ? sp : v.p; };

    // option groups; flavor anchors the rest (only other options get disabled, so a shopper can't get stuck)
    var all = Object.keys(D.variants).map(function (id) { return D.variants[id]; });
    var groups = $$('[data-mz-opt]', root).map(function (el) { return { el: el, i: +el.dataset.optionIndex, kind: el.dataset.mzOpt }; });
    var anchor = groups.filter(function (g) { return g.kind === 'flavor'; })[0] || groups[0];
    var others = groups.filter(function (g) { return g !== anchor; });
    var synced = null, src = null, flvOrder = null;
    var matching = function (want) {
      return all.filter(function (x) { return want.every(function (val, i) { return val == null || x.o[i] === val; }); });
    };

    // Cards follow the selected variant. Sizes the flavor doesn't come in can't be picked; a sold-out size says
    // "Sold out". Flavors that can't be bought in the selected size are greyed with the size they're in stock in
    // (still clickable, the size follows the flavor).
    function syncOptions(v) {
      groups.forEach(function (g) {
        var hint = $('[data-mz-sizehint]', g.el), na = 0, buy = 0, short = 0, rank = {}, cards = $$('label[data-value]', g.el);
        cards.forEach(function (card) {
          var val = card.dataset.value, input = document.getElementById(card.htmlFor);
          var exact = v.o.slice(); exact[g.i] = val;
          var hit = matching(exact)[0], state = hit ? (hit.a ? '' : 'so') : 'na';
          if (g === anchor) {
            var stock = all.filter(function (x) { return x.o[anchor.i] === val && x.a; });
            var sizes = others.length === 1 ? stock.map(function (x) { return x.o[others[0].i]; })
              .filter(function (s, k, a) { return a.indexOf(s) === k; }) : [];
            if (val === v.o[anchor.i]) state = v.a ? '' : 'so';
            else if (state && stock.length) state = 'na';
            else if (state) state = 'so';
            if (state === 'na') na++;
            if (hit && hit.a) buy++;
            else if (stock.length) short++;
            rank[val] = (hit && hit.a) || val === v.o[anchor.i] ? 0 : stock.length ? 1 : 2;
            if (card.classList.contains('is-oos')) state = '';
            var em = $('em', card);
            if (em && !card.classList.contains('is-oos')) {
              em.textContent = state === 'na' ? (sizes.length === 1 ? sizes[0] + ' only' : 'Other sizes') : 'Sold out';
            }
          } else if (state === 'na') {
            var pair = v.o.map(function () { return null; }); pair[anchor.i] = v.o[anchor.i]; pair[g.i] = val;
            if (matching(pair).length) state = '';
            else na++;
          }
          card.classList.toggle('is-na', state === 'na');
          card.classList.toggle('is-so', state === 'so');
          if (g !== anchor) {
            if (input) input.disabled = state === 'na';
            var pp = $('[data-mz-pp]', card);
            if (pp) pp.textContent = state === 'na' ? (anchor.kind === 'flavor' ? 'Not in this flavor' : 'Unavailable')
              : state === 'so' ? 'Sold out' : (hit && hit.s ? money(Math.round(unitFor(hit) / hit.s)) + '/serving' : '');
          }
        });
        if (hint) hint.textContent = na ? 'Not every size comes in this flavor' : '';
        // flavor count: "3 of 9 in 4 lbs" (in stock in the selected size) while some flavors are greyed
        if (g === anchor && g.kind === 'flavor' && others.length === 1) {
          var cnt = $('.mz-optlbl span', g.el);
          if (cnt) {
            if (!cnt.dataset.all) cnt.dataset.all = cnt.textContent;
            cnt.textContent = short ? buy + ' of ' + cards.length + ' in ' + v.o[others[0].i] : cnt.dataset.all;
          }
        }
        // Phones (marz-pdp.css): the swipe row puts flavors you can buy in the selected size first, the selected one
        // included. It only reorders on load and when a size card changes the variant, keeping tiles in their current
        // order where it can, so picking a flavor never shuffles the row under the shopper's finger.
        if (g === anchor && (flvOrder === null || (v !== synced && src && src !== 'option' + (anchor.i + 1)))) {
          var cur = flvOrder || cards.map(function (c) { return c.dataset.value; });
          flvOrder = [0, 1, 2].reduce(function (acc, r) { return acc.concat(cur.filter(function (x) { return rank[x] === r; })); }, []);
          cards.forEach(function (c) { c.style.setProperty('--mz-o', flvOrder.indexOf(c.dataset.value)); });
        }
        // and bring the selected flavor into view on a variant change
        var row = $('.mz-flv', g.el), on = $('input:checked + label', g.el);
        if (g === anchor && v !== synced && row && on && row.scrollWidth > row.clientWidth + 4) {
          var rr = row.getBoundingClientRect(), tr = on.getBoundingClientRect();
          if (tr.left < rr.left || tr.right > rr.right) row.scrollTo({ left: row.scrollLeft + tr.left - rr.left, behavior: reduced ? 'auto' : 'smooth' });
        }
      });
      synced = v;
    }

    function setPriceBox(v) {
      var box = $('[data-mz-price]', root);
      if (!box || !v) return;
      var price = $('[data-product-price]', box), wrap = $('[data-product-price-wrap]', box),
        compare = $('[data-compare-price]', box), save = $('[data-save-price]', box);
      var unit = unitFor(v);
      var base = plan === 'sub' && subPrice(v) != null ? v.p : (v.c > v.p ? v.c : v.p);
      price.innerHTML = money(unit);
      if (base > unit) {
        compare.innerHTML = money(base);
        wrap.classList.remove('hide');
        save.classList.remove('hide');
        save.textContent = 'Save ' + Math.round((1 - unit / base) * 100) + '%';
      } else {
        wrap.classList.add('hide');
        save.classList.add('hide');
      }
    }

    function update() {
      var v = V(vid);
      if (!v) return;
      var sp = subPrice(v);
      var hasSub = !!plansEl && sp != null;
      if (plansEl) {
        $('[data-plan="sub"]', plansEl).style.display = hasSub ? '' : 'none';
        if (!hasSub && plan === 'sub') plan = 'one';
        $$('.mz-plan', plansEl).forEach(function (pl) {
          var on = pl.dataset.plan === plan;
          pl.classList.toggle('is-on', on);
          var r = $('input[type=radio]', pl); if (r) r.checked = on;
        });
        if (hasSub) {
          $('[data-mz-subpr]', plansEl).innerHTML = '<s>' + money(v.p) + '</s>' + money(sp);
          $('[data-mz-subper]', plansEl).textContent = perServing(sp, v);
        }
        $('[data-mz-onepr]', plansEl).innerHTML = (v.c > v.p ? '<s>' + money(v.c) + '</s>' : '') + money(v.p);
        $('[data-mz-oneper]', plansEl).textContent = perServing(v.p, v);
        $$('[data-mz-freq]', plansEl).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.mzFreq === freq)); });
      }
      if (spInput) { spInput.disabled = plan !== 'sub'; if (freq) spInput.value = freq; }
      setPriceBox(v);

      syncOptions(v);

      // price on the add-to-cart button (theme.js resets the label on variant change)
      if (atc && atcText && v.a) {
        atcText.innerHTML = (atcText.dataset.defaultText || 'Add to cart') + '<span class="mz-sep">|</span>' + money(unitFor(v));
      }

      if (sticky) {
        var info = $('[data-mz-sinfo]', sticky), img = $('[data-mz-simg]', sticky), tog = $('[data-mz-stog]', sticky), btn = $('[data-mz-sbtn]', sticky);
        if (info) info.textContent = (v.t && v.t !== 'Default Title' ? v.t + ' · ' : '') + money(unitFor(v)) + (plan === 'sub' && sp != null ? ' · Subscribe & Save' : '');
        if (img && v.img) img.src = v.img;
        if (tog) { tog.style.display = hasSub ? '' : 'none'; tog.setAttribute('aria-checked', String(plan === 'sub')); }
        if (btn) { btn.disabled = !v.a; btn.textContent = v.a ? (atcText && atcText.dataset.defaultText || 'Add to cart') : 'Sold out'; }
      }
    }

    root.addEventListener('variantChange', function (e) {
      if (e.detail && e.detail.variant) vid = String(e.detail.variant.id);
      src = e.detail && e.detail.index; // option group that changed (option1 = flavor here)
      setTimeout(update, 0); // after theme.js has finished its own price + button updates
    });
    root.addEventListener('variantPriceChange', function () { setTimeout(update, 0); });

    if (plansEl) {
      $$('input[type=radio]', plansEl).forEach(function (r) {
        r.addEventListener('change', function () { plan = r.value; update(); });
      });
      $$('[data-mz-freq]', plansEl).forEach(function (b) {
        b.addEventListener('click', function () { freq = b.dataset.mzFreq; update(); });
      });
    }

    if (sticky) {
      var tog = $('[data-mz-stog]', sticky), sbtn = $('[data-mz-sbtn]', sticky);
      if (tog) tog.addEventListener('click', function () { plan = plan === 'sub' ? 'one' : 'sub'; update(); });
      if (sbtn) sbtn.addEventListener('click', function () { if (atc && !atc.disabled) atc.click(); });
      if (atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var off = !entries[0].isIntersecting;
          sticky.classList.toggle('is-on', off);
          sticky.setAttribute('aria-hidden', String(!off));
          document.body.classList.toggle('mz-sticky-on', off);
        }, { threshold: 0 }).observe(atc);
      }
    }

    autoAdvanceOnce($('[data-mz-assure]', root));
    update();
    // theme.js may re-render the button label after load; re-apply once it settles
    setTimeout(update, 600);
  }

  /* ---------------- label panels follow the selected variant ---------------- */
  function initLabel(sec) {
    if (sec.dataset.mzReady) return;
    sec.dataset.mzReady = '1';
    var map = {};
    var mapEl = $('[data-mz-label-map]', sec);
    try { map = JSON.parse(mapEl ? mapEl.textContent : '{}'); } catch (e) {}
    var sel = $('[data-mz-panel-select]', sec);
    function show(key) {
      $$('[data-mz-panel]', sec).forEach(function (p) { p.hidden = p.dataset.mzPanel !== key; });
      if (sel) sel.value = key;
    }
    if (sel) sel.addEventListener('change', function () { show(sel.value); });
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && map[String(v.id)]) show(map[String(v.id)]);
    });
  }

  /* ---------------- key ingredient flip cards ---------------- */
  function initIngredients(sec) {
    if (sec.dataset.mzReady) return;
    sec.dataset.mzReady = '1';
    $$('.mz-ig.can-flip', sec).forEach(function (card) {
      var flip = function () {
        var on = card.classList.toggle('is-flipped');
        card.setAttribute('aria-pressed', String(on));
        var back = $('.mz-ig-back', card), front = $('.mz-ig-front', card);
        if (back) back.setAttribute('aria-hidden', String(!on));
        if (front) front.setAttribute('aria-hidden', String(on));
      };
      card.addEventListener('click', function (e) { if (e.target.closest('a')) return; flip(); });
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
    });
    var first = $('.mz-ig.can-flip', sec);
    if (first && !reduced && 'IntersectionObserver' in window) {
      var ob = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { first.classList.add('is-peek'); setTimeout(function () { first.classList.remove('is-peek'); }, 1100); ob.disconnect(); }
      }, { threshold: 0.6 });
      ob.observe(first);
    }
    var more = $('.mz-ig-more', sec);
    if (more) more.addEventListener('click', function () {
      var open = sec.classList.toggle('is-open');
      more.setAttribute('aria-expanded', String(open));
      more.textContent = open ? more.dataset.less : more.dataset.more;
      if (!open) sec.scrollIntoView({ block: 'start' });
    });
  }

  /* ---------------- FAQ topic chips ---------------- */
  function initFaq(sec) {
    if (sec.dataset.mzReady) return;
    sec.dataset.mzReady = '1';
    $$('.mz-chips button', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.dataset.topic;
        $$('.mz-chips button', sec).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        $$('.mz-qa', sec).forEach(function (q) { q.style.display = t === 'all' || q.dataset.topic === t ? '' : 'none'; });
      });
    });
  }

  /* ---------------- stack: quick add + recommendations fallback ---------------- */
  function initStack(sec) {
    if (sec.dataset.mzReady) return;
    sec.dataset.mzReady = '1';
    var bind = function () {
      $$('[data-mz-add]', sec).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          b.disabled = true;
          fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: +b.dataset.mzAdd, quantity: 1 }] })
          }).then(function (r) { return r.json(); }).then(function (data) {
            b.disabled = false;
            var item = data && data.items ? data.items[0] : data;
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: b } }));
          }).catch(function () { b.disabled = false; });
        });
      });
    };
    var url = sec.dataset.mzRecs;
    if (url) {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-mz-stack-inner]');
        var cur = $('[data-mz-stack-inner]', sec);
        if (fresh && cur && fresh.querySelector('.mz-rc')) { cur.innerHTML = fresh.innerHTML; sec.hidden = false; bind(); }
      }).catch(function () {});
    } else {
      bind();
    }
  }

  function boot() {
    patchVariants();
    $$('[data-mz-pdp]').forEach(initPdp);
    $$('[data-mz-label]').forEach(initLabel);
    $$('[data-mz-ingr]').forEach(initIngredients);
    $$('[data-mz-faq]').forEach(initFaq);
    $$('[data-mz-stack]').forEach(initStack);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
